export default __webpack_public_path__ + "static/smartWorkflowImg3-1053f2bc4f85423dc833c7852af43408.png";